import { useMediaQuery } from 'Hooks';
import { breakpoints } from 'Constants';

type Hook = () => { mobile: boolean; desktop: boolean };

export const useDeviceDetect: Hook = () => {
  const breakpoint = breakpoints['md'];
  const isDesktop = useMediaQuery(`(min-width: ${breakpoint})`);

  return { mobile: !isDesktop, desktop: isDesktop };
};
